import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { memo } from 'react';
import MessageHeaderRecipientCount from '../email/MessageHeaderRecipientCount';
import { getEmailMetadata } from 'conversations-message-history/common-message-format/operators/getEmailMetadata';
import { getTotalRecipientsCount } from '../common-message/operators/getTotalRecipientsCount';
// @ts-expect-error module not typed
import { isCommonMessageFormat } from 'conversations-message-history/common-message-format/operators/cmfComparators';
import FullSenderName from '../senders/components/FullSenderName';
import CommonMessageHeaderPopover from '../common-message-popover/CommonMessageHeaderPopover';
import Small from 'UIComponents/elements/Small';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import { VISITOR } from 'conversations-message-history/common-message-format/constants/legacySenderTypes';
import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import { getSenderType } from 'conversations-message-history/senders/operators/getters';
import { sourceIconsMap, FALLBACK_ICON } from 'conversations-message-history/constants/sourceIcons';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import I18n from 'I18n';
import { getGenericChannelIdForMessage, getSenders, getMessageDirection, getRecipients } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { getCallMetadataAttachment
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
} from 'conversations-message-history/call/operators/callMetadataAttachmentGetters';
import { INCOMING } from 'conversations-message-history/common-message-format/constants/messageDirections';
import FullRecipientName from '../recipients/components/FullRecipientName';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyledSenderName = styled.strong.withConfig({
  displayName: "CommonMessageHeaderContent__StyledSenderName",
  componentId: "sc-1jxffkm-0"
})(["margin-right:4px;"]);
export const StyledUIIcon = styled(UIIcon).withConfig({
  displayName: "CommonMessageHeaderContent__StyledUIIcon",
  componentId: "sc-1jxffkm-1"
})(["span::before{position:relative;top:", ";}"], ({
  name
}) => name === 'socialFacebookMessenger' && '-1px');
export const StyledHeaderSpans = styled.span.withConfig({
  displayName: "CommonMessageHeaderContent__StyledHeaderSpans",
  componentId: "sc-1jxffkm-2"
})(["font-weight:300;margin-right:6px;"]);
const IconFallback = () => /*#__PURE__*/_jsx(UITooltip, {
  title: I18n.text('conversations-inbox-message-history.common-message.unknownChannelMessage'),
  children: /*#__PURE__*/_jsx(StyledUIIcon, {
    className: "m-right-2",
    name: FALLBACK_ICON,
    "data-test-id": "message-header-channel-fallback-icon"
  })
});
IconFallback.displayName = 'IconFallback';
const MaybeRenderIcon = ({
  genericChannelId,
  channelName
}) => {
  const iconName = sourceIconsMap[genericChannelId];
  if (iconName) {
    return /*#__PURE__*/_jsx(UITooltip, {
      title: channelName,
      children: /*#__PURE__*/_jsx(StyledUIIcon, {
        className: "m-right-2",
        name: iconName,
        "data-test-id": "message-header-channel-icon"
      })
    });
  }
  return /*#__PURE__*/_jsx(IconFallback, {});
};
MaybeRenderIcon.displayName = 'MaybeRenderIcon';
const CallInfoHeader = ({
  message,
  recipient,
  isRecipientLoading,
  sender,
  senderName,
  isSenderLoading
}) => {
  const direction = getMessageDirection(message);
  let directionI18nKey;
  let name;
  if (direction === INCOMING) {
    directionI18nKey = 'conversations-inbox-message-history.common-message.call-header.direction.inbound';
    name = /*#__PURE__*/_jsx(FullSenderName, {
      sender: sender,
      senderName: senderName,
      isLoading: isSenderLoading
    });
  } else {
    directionI18nKey = 'conversations-inbox-message-history.common-message.call-header.direction.outbound';
    name = /*#__PURE__*/_jsx(FullRecipientName, {
      recipient: recipient,
      isLoading: isRecipientLoading
    });
  }
  return /*#__PURE__*/_jsx(FormattedReactMessage
  // eslint-disable-next-line conversations/no-dynamic-i18n
  , {
    message: directionI18nKey,
    options: {
      name
    }
  });
};
CallInfoHeader.displayName = 'CallInfoHeader';
const CommonMessageHeaderContent = ({
  channelName,
  isForwarded,
  isRecipientLoading,
  isSenderLoading,
  message,
  recipient,
  sender,
  senderName,
  iconShouldMinimize
}) => {
  const isEmailMessage = isCommonMessageFormat(message) && Boolean(getEmailMetadata(message));
  const totalRecipients = isEmailMessage ? getTotalRecipientsCount({
    message: message
  }) : 0;
  const recipientCount = isEmailMessage && /*#__PURE__*/_jsx(MessageHeaderRecipientCount, {
    count: totalRecipients,
    isForwarded: isForwarded
  });
  const genericChannelId = getGenericChannelIdForMessage(message);
  const genericSenders = getSenders(message);
  const genericRecipients = getRecipients(message);
  const onDark = sender ? getSenderType(sender) === VISITOR : undefined;
  const isCalling = isCommonMessageFormat(message) && Boolean(getCallMetadataAttachment(message));
  if (isSenderLoading || isCalling && isRecipientLoading) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      width: 150,
      use: onDark ? 'on-dark' : 'default'
    });
  }
  return /*#__PURE__*/_jsxs(Small, {
    children: [/*#__PURE__*/_jsx(StyledSenderName, {
      "data-test-id": "sender-name",
      children: isCalling ? /*#__PURE__*/_jsx(CallInfoHeader, {
        message: message,
        recipient: recipient,
        isRecipientLoading: isRecipientLoading,
        sender: sender,
        senderName: senderName,
        isSenderLoading: isSenderLoading,
        genericSenders: genericSenders,
        genericRecipients: genericRecipients
      }) : /*#__PURE__*/_jsx(FullSenderName, {
        sender: sender,
        senderName: senderName,
        genericSenders: genericSenders
      })
    }), recipientCount, /*#__PURE__*/_jsx(StyledHeaderSpans, {
      "aria-hidden": "true",
      className: "is--text--help",
      children: `•`
    }), /*#__PURE__*/_jsx(StyledHeaderSpans, {
      className: "is--text--help",
      children: iconShouldMinimize ? /*#__PURE__*/_jsx(MaybeRenderIcon, {
        genericChannelId: genericChannelId,
        channelName: channelName
      }) : channelName || /*#__PURE__*/_jsx(IconFallback, {})
    }), /*#__PURE__*/_jsx(CommonMessageHeaderPopover, {
      message: message,
      sender: sender,
      isSenderLoading: isSenderLoading,
      recipient: recipient,
      isRecipientLoading: isRecipientLoading,
      isForwarded: isForwarded
    })]
  });
};
CommonMessageHeaderContent.displayName = 'CommonMessageHeaderContent';
export default /*#__PURE__*/memo(CommonMessageHeaderContent);